// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"492":"fb87c644","517":"cdfda08b","745":"fb87c644","930":"fb87c644"}[chunkId] + ".chunk.css";
};